import { render, staticRenderFns } from "./FlutterWavePayment.vue?vue&type=template&id=68cee228&scoped=true&"
import script from "./FlutterWavePayment.vue?vue&type=script&lang=js&"
export * from "./FlutterWavePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cee228",
  null
  
)

export default component.exports